import React from "react"
import { Link } from "gatsby"
import { useHits, Snippet } from "react-instantsearch"
import { Ep } from "../el/searchelements"
import { ResourcePill, TypePill, ProductPill } from "./searchhitresourcepills"
// resources hit component
const CustomResourceHits = () => {
  const { items } = useHits()

  return items.length === 0 ? (
    <Ep>Your search yields no results, try searching something else.</Ep>
  ) : (
    items.map(item => {
      return (
        <Link
          key={item.objectID}
          to={item.slug}
          className="block border-b border-gray-200 px-2 py-3"
        >
          <div className="flex items-start">
            {item.thumbnail !== "" && (
              <div className="mr-2.5 mt-1.5 h-14 w-24 shrink-0 overflow-hidden rounded bg-pink-200">
                <img
                  alt={item.thumbnail}
                  src={`/video-thumbnails/${item.thumbnail}`}
                  className="h-full w-full"
                />
              </div>
            )}
            <div>
              <h3 className="text-sm font-medium text-gray-800">
                <Snippet
                  hit={item}
                  attribute="title"
                  highlightedTagName="mark"
                />
              </h3>
              <p className="text-xs font-light text-gray-700">
                <Snippet
                  hit={item}
                  attribute="description"
                  highlightedTagName="mark"
                />
              </p>
            </div>
          </div>
          <div className="mt-1.5 space-x-3 pt-0.5">
            <TypePill type={item.type} />
            <ProductPill product={item.productLine} />
            {item.type === "PW" ||
              (item.type === "GI" && <ResourcePill text={item.linkType} />)}
          </div>
        </Link>
      )
    })
  )
}

export default CustomResourceHits
